<script context="module">export var CaptchaTheme = /* @__PURE__ */ ((CaptchaTheme2) => {
  CaptchaTheme2["DARK"] = "dark";
  CaptchaTheme2["LIGHT"] = "light";
  return CaptchaTheme2;
})(CaptchaTheme || {});
</script>

<script>import { createEventDispatcher, onMount } from "svelte";
const dispatch = createEventDispatcher();
export let sitekey;
export let apihost = "https://js.hcaptcha.com/1/api.js";
export let hl = "";
export let reCaptchaCompat = false;
export let theme = CaptchaTheme.LIGHT;
export let size = "normal";
export const reset = () => {
  if (mounted && loaded && widgetID) hcaptcha.reset(widgetID);
};
export const execute = (options) => {
  if (mounted && loaded && widgetID) return hcaptcha.execute(widgetID, options);
};
const id = Math.floor(Math.random() * 100);
let mounted = false;
let loaded = false;
let widgetID;
const query = new URLSearchParams({
  recaptchacompat: reCaptchaCompat ? "on" : "off",
  onload: "hcaptchaOnLoad",
  render: "explicit"
});
onMount(() => {
  if (!sitekey) sitekey = window.sitekey;
  window.hcaptchaOnLoad = () => {
    dispatch("load");
    loaded = true;
  };
  window.onSuccess = (token) => {
    dispatch("success", { token });
  };
  window.onError = () => {
    dispatch("error");
  };
  window.onClose = () => {
    dispatch("close");
  };
  window.onExpired = () => {
    dispatch("expired");
  };
  dispatch("mount");
  mounted = true;
  return () => {
    window.hcaptchaOnLoad = null;
    window.onSuccess = null;
    if (loaded) {
      hcaptcha.reset(widgetID);
      hcaptcha.remove(widgetID);
      hcaptcha = null;
    }
  };
});
$: if (mounted && loaded) {
  widgetID = hcaptcha.render(`h-captcha-${id}`, {
    sitekey,
    hl,
    // force a specific localisation
    theme,
    callback: "onSuccess",
    "error-callback": "onError",
    "close-callback": "onClose",
    "expired-callback": "onExpired",
    size
  });
}
</script>

<svelte:head>
  {#if mounted && !window?.hcaptcha}
    <script src={`${apihost}?${query}`} async defer></script>
  {/if}
</svelte:head>

<div id="h-captcha-{id}" />
